import CircularProgress from '@mui/material/CircularProgress'
import { Alert, Box } from '@mui/material'
import { useParams } from 'react-router-dom'

import {
  PowerBiReportFilter,
  PowerBiReportRenderer,
} from '~components/power-bi-report-renderer'
import { getPoolCompanyCode } from '~constants/pools'
import { useGetMe } from '~hooks/queries/me/use-get-me'
import { powerBiPoolFilterDefaults } from '../../../../constants/power-bi'
import { ReportWithToken } from '../../../../hooks/queries/reports/use-power-bi-report-with-token'

const companyCodeTarget = {
  column: 'Company Code',
  table: 'Compliance Fleet',
}

export function FuelEUReport({
  selectedReport,
}: {
  selectedReport: ReportWithToken
}) {
  const { pool } = useParams()
  const { data, isLoading, isError } = useGetMe()
  const companyCode = getPoolCompanyCode(pool)

  if (isLoading) {
    return <CircularProgress aria-label="Loading…" />
  }

  if (isError) {
    return (
      <Box sx={{ m: 3 }}>
        <Alert severity="error">
          Oops! There was an error getting your user. Please reload the page or
          try again later.
        </Alert>
      </Box>
    )
  }

  if (!companyCode) {
    return (
      <Box sx={{ mb: 3 }}>
        <Alert severity="info">
          Unfortunately, there is no data for this pool.
        </Alert>
      </Box>
    )
  }

  // all pools' partners are shown for staff, so only the company code filter applies
  if (data?.isInternal) {
    return (
      <PowerBiReportRenderer
        defaultFilters={{
          ...powerBiPoolFilterDefaults,
          target: companyCodeTarget,
        }}
        report={selectedReport}
        customValue={companyCode}
      />
    )
  }

  const companyCodeFilter: PowerBiReportFilter = {
    ...powerBiPoolFilterDefaults,
    target: companyCodeTarget,
    operator: 'In',
    values: [companyCode],
  }

  return (
    <PowerBiReportRenderer
      defaultFilters={{
        ...powerBiPoolFilterDefaults,
        target: {
          column: 'Pool Partner Key',
          table: 'Compliance Fleet',
        },
      }}
      report={selectedReport}
      customValue={
        data?.poolPartnerKeys && data?.poolPartnerKeys.length > 0
          ? data?.poolPartnerKeys[0]
          : undefined
      }
      additionalFilters={[companyCodeFilter]}
    />
  )
}
